import { useRequiredParams } from '@pba/react-router';
import { CommunityLayout, CommunityMembers } from 'features/communities';

type RoutingParams = {
  communityId: string;
};

export const PageCommunityMembers = () => {
  const { communityId } = useRequiredParams<RoutingParams>();

  return (
    <CommunityLayout
      children={(community) => <CommunityMembers community={community} />}
      communityId={communityId}
      tab="/members"
    />
  );
};
